module.exports = __webpack_public_path__ + "img/end-chat-icon.6dd35c4b.svg";